import ZkDictionaryValue from './src/main'
ZkDictionaryValue.install = function (Vue) {
  Vue.component(ZkDictionaryValue.name, ZkDictionaryValue)
}
export default ZkDictionaryValue



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/dictionValue/index.js